import { stripCohortSuffix } from 'helpers/stripCohortSuffix'

const STEP_NAME_KEYS = ['screen_name', 'page_name', 'question'] as const

export const sanitizeEventProperty = (
  eventProperty?: Record<string, unknown>,
): Record<string, unknown> | undefined => {
  if (!eventProperty) return eventProperty
  let next: Record<string, unknown> | undefined
  for (const key of STEP_NAME_KEYS) {
    const v = eventProperty[key]
    if (typeof v === 'string') {
      const cleaned = stripCohortSuffix(v)
      if (cleaned !== v) {
        next = next || { ...eventProperty }
        next[key] = cleaned
      }
    }
  }
  return next || eventProperty
}
